import * as React        from "react"
import {PacyAccount}     from "../../../../model/pacy/"
import BudgetPlanner1    from "../../budgetPlanner1/BudgetPlanner"
import PacyLoader        from "../../../../components/loaders/pacyLoader"
import Loading           from "../../../../components/loading/"
import PacingRatio from "./PacingRatio"

interface PacingRatioContainerOwnProps{
}
interface PacingRatioContainerProps extends PacingRatioContainerOwnProps{
  account     : PacyAccount
  loadingPacy : boolean
}

const PacingRatioContainer = (props:PacingRatioContainerProps) => {
  if(props.loadingPacy){return <Loading translateId="loadings.budgetPlanner"/>}
  if(!props.account){return <BudgetPlanner1/>} // Old Budget Planner, should be shown if Pacy account is not migrated/created yet
  return <PacingRatio/>
}

export default PacyLoader()(PacingRatioContainer) as React.ComponentType<PacingRatioContainerOwnProps>
